<lazy-echart
    class="chart"
    [class.chart--fixed-height]="hasFixedHeight"
    [compactLoading]="compactLoading"
    [options]="chartOptions"
    (chartClick)="chartClicked($event)"
></lazy-echart>
